import { Row } from 'react-bootstrap';
import useServicesData from '../../Hooks/useServicesData';
import Service from '../Service/Service';

const Services = () => {
   const [services, setServices] = useServicesData();

    return (
        <div className='m-2'>
            <h1 className='bg-success p-2 rounded-3 text-center text-white shadow'>My all services for my Students</h1>

    <Row xs={1} md={2} lg={3} className="g-4">
    {
        services.map( service => <Service key={service.id} service={service}></Service>)

    }
</Row>
        </div>
    );
};

export default Services;